<template>
  <div class="legal-portal">
    <div class="portal-header">
      <h2 class="portal-title">法律应用</h2>
      <p class="portal-desc">根据您的权限，可使用以下法律应用功能</p>
    </div>

    <a-spin :spinning="loading">
      <div v-if="apps.length > 0" class="app-grid">
        <div
          v-for="app in apps"
          :key="app.id"
          class="app-card"
          @click="openApp(app)"
        >
          <div class="app-icon">
            <component :is="getIcon(app.icon)" />
          </div>
          <div class="app-info">
            <div class="app-name">{{ app.moduleName || app.actionName }}</div>
            <div class="app-area" v-if="app.areaName">{{ app.areaName }}</div>
          </div>
        </div>
      </div>

      <a-empty v-else-if="!loading" description="暂无可用的法律应用权限" />
    </a-spin>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import {
  SearchOutlined,
  MessageOutlined,
  FileTextOutlined,
  AuditOutlined,
  BookOutlined,
  SafetyOutlined,
  AppstoreOutlined,
  LinkOutlined,
} from '@ant-design/icons-vue';
import { getUserMenus } from '@/api/permission';

const apps = ref([]);
const loading = ref(false);

// 图标映射：根据权限表录入的icon名称返回组件
const iconMap = {
  search: SearchOutlined,
  consult: MessageOutlined,
  message: MessageOutlined,
  file: FileTextOutlined,
  audit: AuditOutlined,
  book: BookOutlined,
  safety: SafetyOutlined,
  appstore: AppstoreOutlined,
  link: LinkOutlined,
};

const getIcon = (icon) => {
  if (!icon) return AppstoreOutlined;
  return iconMap[icon.toLowerCase()] || AppstoreOutlined;
};

// 打开应用：新窗口跳转到功能URL
const openApp = (app) => {
  if (!app.url) {
    message.warning('该功能未配置访问地址');
    return;
  }
  window.open(app.url, '_blank');
};

const fetchMenus = async () => {
  loading.value = true;
  try {
    const res = await getUserMenus();
    if (res.code === 200 && res.data) {
      apps.value = res.data;
    } else {
      apps.value = [];
    }
  } catch (error) {
    console.error('获取法律应用列表失败:', error);
    message.error('获取应用列表失败');
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchMenus();
});
</script>

<style scoped>
.legal-portal {
  padding: 24px;
}

.portal-header {
  margin-bottom: 24px;
}

.portal-title {
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #1f1f1f;
}

.portal-desc {
  color: #8c8c8c;
  margin: 0;
}

.app-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

.app-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.app-card:hover {
  border-color: #69b1ff;
  box-shadow: 0 4px 16px rgba(22, 119, 255, 0.12);
  transform: translateY(-2px);
}

.app-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6f4ff;
  color: #1677ff;
  border-radius: 8px;
  font-size: 20px;
  flex-shrink: 0;
}

.app-info {
  flex: 1;
  min-width: 0;
}

.app-name {
  font-size: 15px;
  font-weight: 500;
  color: #1f1f1f;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-area {
  font-size: 12px;
  color: #bfbfbf;
}
</style>
